export const SC_MEMBER = 'Selection Committee Member'
export const AC_MEMBER = 'Allocation Committee Member'
